import { ForexTemplateState } from "@/feature/Forex/store/template/interface";
import { mapForexTemplate } from "@/feature/Forex/api/template/forex-template.utils";

export default <ForexTemplateState> {
	list: [],
	loadingCount: 0,
	isEndPage: false,
	pageSize: 25,
	pageNumber: 1,
	currentTemplate: mapForexTemplate(),
}